import c1 from "./assets/clients/labfix.png";
import c2 from "./assets/clients/client1.jpeg";
import c3 from "./assets/clients/transcal.jpeg";
import c4 from "./assets/clients/chavank.jpeg";
import c5 from "./assets/clients/accurate.jpeg";
import c6 from "./assets/clients/kesar.jpeg";
import c7 from "./assets/clients/client2.png";
import c8 from "./assets/clients/client4.jpg";
import c9 from "./assets/clients/consip.png";
import c10 from "./assets/clients/vaidya.png";
import c11 from "./assets/clients/rone.png";
import c12 from "./assets/clients/reva.jpg";
import s1 from "./assets/service1.png";
import s2 from "./assets/service2.png";
import s3 from "./assets/service3.png";
import s4 from "./assets/service4.png";
import s5 from "./assets/service5.png";
import p1 from "./assets/lims.png";
import p2 from "./assets/product2.jpg";
import p3 from "./assets/product3.png";
import p4 from "./assets/product4.png";
import labAxis from "./assets/LabAxis.png";
import tpi360 from "./assets/TPI360.png";
import tpiMarketing from "./assets/TPI Marketing -1.png";

export const clientsData = [
  {
    id: 8,
    imageSrc: c1,
    name: "Labfix, South Africa",
  },
  {
    id: 1,
    imageSrc: c2,
    name: "Spartan India PVT LTD",
  },
  {
    id: 2,
    imageSrc: c3,
    name: "Transcal Technologies LLP",
  },
  {
    id: 3,
    imageSrc: c4,
    name: "Chavanke Engineering Pvt. Ltd.",
  },
  {
    id: 4,
    imageSrc: c5,
    name: "Accurate Services & Enterprises",
  },
  {
    id: 5,
    imageSrc: c6,
    name: "kesar Testing Services LLP",
  },
  {
    id: 6,
    imageSrc: c7,
    name: "Perfect Utilities",
  },
  {
    id: 7,
    imageSrc: c8,
    name: "Electrosteel Castings Limited",
  },
  {
    id: 9,
    imageSrc: c9,
    name: "Consip Group of Companies Pvt. Ltd.",
  },
  {
    id: 10,
    imageSrc: c10,
    name: "Vaidyanatheshwara Instruments Pvt. Ltd.",
  },
  {
    id: 11,
    imageSrc: c11,
    name: " R-One Tech",
  },
  {
    id: 12,
    imageSrc: c12,
    name: "Reva Phoenix Labs & Consultants Pvt. Ltd.",
  },
];

export const ourService = [
  {
    id: 1,
    image: s1,
    title: "Custom Software Development",
    description:
      "Our Specialised Customized Software Development is the process of Designing, Building, Deploying, and Maintaining Software for all types of SMEs and MSMEs that is tailored to their needs and aims",
  },
  {
    id: 2,
    image: s2,
    title: "App Development",
    description:
      "Our Application Development assist you in creating beneficial and efficient experiences on every device and help you get the most out of Mobile Technology for your business with our Application",
  },
  {
    id: 3,
    image: s3,
    title: "E-Commerce Solutions",
    description:
      "Our E-Commerce Software facilitates quicker and trusted growth of income and profit for both, beginner's playground, and an expert home field by meeting the demands of any small- to medium-sized firm.",
  },
  {
    id: 4,
    image: s4,
    title: "Software Consulting      ",
    description:
      "Trigun Software Consulting services diagnose, analyze, identify, plan, and offer solutions that are compatible with every organization's needs. Expertizing our knowledge and experience at all instances accelerates   ",
  },
  {
    id: 5,
    image: s5,
    title: "Cyber Secuirty",
    description:
      "To guarantee that your Systems and Data are safe, Trigun Cyber Security Employs a Patented Technique to execute a controlled external real-life evaluation and penetration test of your firewalls, Network",
  },
];

export const prductData = [
  {
    id: 1,
    image: p1,
    title: "Laboratory Information Management System (LIMS)",
    headline: "Your Ultimate Solution for Calibration Excellence.",
    description:
      "Our advanced LIMS is purpose-built for calibration labs, designed to simplify your operations while ensuring compliance with ISO/IEC 17025 and NABL 129. LIMS will bring complete automation to the calibration task . \nAccurate Audit Documents , Errorless Reports ,Precise uncertainty Count And well projected Engineers work Reports.",
    subpoints:
      "1. Track your Customer’s calibration Instruments & your Calibration Masters with QR code labels, real-time Due alerts, etc. 2. Onsite / Inhouse Offline Calibration: Take Lab City onsite even if there is no connectivity. Perform Calibration And get Auto-Generated Certificate From Raw Datasheet. When you are back in the network Offline Data Will Sync With Server Database. 3. Assign jobs to technicians based on Work. Track progress And Get Detailed Work Report. 4. Automate uncertainties & CMC Validation. 5. Auto sends recall emails to clients And Lab For DUC Dues, Master Dues. 6. Client Portal: Deliver calibration certificates via customer self-service Portals. 7. Generate Calibration certificates and labels from raw data. Complies with the requirements of FDA 21 CFR PART 11 And ISO 17025.",
  },
  {
    id: 5,
    image: labAxis,
    title: "LabAxis ERP Software",
    headline: "Complete ERP + LIMS Software for NABL Testing Labs",
    description:
      "LabAxis is a complete software solution designed for NABL testing laboratories to manage the full workflow from Enquiry to Final Certificate in one platform.\n\nIt helps testing labs improve traceability, approval control, reporting, billing, and audit readiness.\n\nComplete Workflow:\nEnquiry → Quotation → Job Creation → Unique Job No. → Inward → Test Selection → Observation Sheet → Technician Assignment → Review → Authorized Sign → Final Certificate with QR Verification",
    subpoints:
      "1. Key Modules: Enquiry | Quotation & Invoice | Job Creation with unique job number | Inward & test selection | Lab / Onsite / Mobile testing flow | Observation sheet generation | Technician assignment with accept/reject option | Test details entry and approval flow | Reviewer and authorized sign approval | Final certificate with QR verification | Employee management | Attendance & leave management | Requirement approval for onsite/travel/hotel charges | Management reports. 2. Reports: Month-wise test summary | Work report | Department-wise progress report | Test status report | Job-wise report | Pending approval report | Commercial and invoice reports. 3. Benefits: Reduces manual work | Improves traceability | Faster certificate generation | Better approval control | Audit-ready records | Complete management visibility. 4. Suitable For: Mechanical testing labs | Civil / construction material testing labs | Chemical testing labs | Environmental testing labs | Food testing labs | Electrical testing labs | Geotechnical testing labs | Multi-discipline NABL testing labs.",
  },
  {
    id: 2,
    image: p2,
    title: "Instrument Management System (IMS)",
    description:
      "The Instrument Management System (IMS) is an advanced software solution designed for industries to streamline the maintenance of their calibration records. \nIMS minimizes the administrative workload by automating calibration tracking and due reminders, while also providing a comprehensive history card for each instrument.",
    subpoints:
      "1. The Instrument Management System (IMS) is an advanced software solution designed for industries to streamline the maintenance of their calibration records. 2. IMS minimizes the administrative workload by automating calibration tracking and due reminders, while also providing a comprehensive history card for each instrument. 3. With vendor login access, calibration vendors can directly update all calibration records, eliminating the need for manual data entry by the industry. 4. This efficient approach enhances accuracy, compliance, and accessibility, making IMS an essential tool for any industry committed to maintaining precise calibration management.",
  },
  {
    id: 7,
    image: tpi360,
    marketingImage: tpiMarketing,
    title: "TPI360",
    headline: "Third Party Inspection (TPI) Management Application",
    description:
      "Third Party Inspection (TPI) Management Application, specially designed for NABCB-accredited inspection bodies to streamline inspection operations, improve traceability, and enhance operational efficiency.\n\nOur application digitizes the complete inspection workflow — from enquiry generation to certificate release — through a centralized and intelligent platform.",
    subpoints:
      "1. Key Modules & Features: Employee Management | Attendance & Leave Management | Inspector Competency Matrix | SOP & Checklist Management with User Assignment | Complete Commercial Workflow: Enquiry → Quotation → PO → Invoice. 2. Core Inspection Workflow: Centralized Job Register Management | Upload Important Documents Against Job: QAP, Drawings, Technical Specifications, Procedures, etc. | Smart Inspector Job Assignment based on location and competency | Inspector Job Acceptance / Rejection Provision | Inspector Access to QAP and Job-Related Documents through Login | Digital Inspection Reporting with: Inspection Reports (IR), Witness Reports, Review Reports, Type Test Certificates, Testing Photo Attachments. 3. Approval Workflow: Inspector submits Inspection Report for approval | Reviewer can Approve / Reject with remarks | Auto-generation of Certificate Release Note after approval. 4. Additional Management Benefits: Inspector Timesheet Management | Expense Entry Tracking | Travel Distance Monitoring | Working Hour Monitoring | Activity Traceability & Job Status Tracking | Centralized Document Control. 5. Benefits for NABCB Inspection Bodies: Improved operational control and transparency | Faster inspection report processing | Reduced manual documentation work | Better inspector monitoring and competency tracking | Enhanced document traceability and compliance management | Efficient commercial and technical workflow integration.",
  },
  {
    id: 4,
    image: p4,
    title: "Master QR",
    description:
      "Master QR provides a unified tracking system for all your industrial assets and equipment using smart QR codes. Instant access to equipment history, manuals, and maintenance schedules with a simple scan.",
    subpoints:
      "1. Unique QR code generation for every asset. 2. Mobile scanning for instant information retrieval. 3. Complete maintenance and calibration history tracking. 4. Document management for manuals and certificates. 5. Automated alerts for upcoming maintenance. 6. Centralized asset database management.",
  },
  {
    id: 3,
    image: p3,
    title: "Smart AMC",
    description:
      "Smart AMC is designed to help industries manage their Annual Maintenance Contracts efficiently. Never miss a service date again with automated reminders and comprehensive contract tracking.",
    subpoints:
      "1. Centralized contract management and tracking. 2. Automated service reminders and scheduling. 3. Performance tracking for service providers. 4. Detailed service history and documentation. 5. Cost analysis and budgeting tools. 6. Customer portal for service requests.",
  },
];
